import BotStore from '@src/store';
import CommonStore from '@src/stores/CommonStore';

export const listenToStores = [BotStore, CommonStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    allStories: BotStore.getAllStories(),
    domain: CommonStore.getMetaTags().domain,
    meta: CommonStore.getMetaTags(),
  };
}

export { getAllStories, setCurrentScreen } from 'actions/StoryActions';
export {
  openComponentModal,
  createNewStory,
  closeComponentModal,
  createAlert,
} from '@src/actions/BotActions';
export { makeStoryActive, makeStoryInactive } from '@src/actions/StoryActions';
